import api from "@/api";
import events from "@/events";

let previousConsent;

const trackConsent = () => {
  const consent = window.Cookiebot.consent;

  if (previousConsent.statistics === consent.statistics &&
    previousConsent.marketing === consent.marketing) {
    return;
  }

  api.consents.trackConsent(consent);

  previousConsent = {
    statistics: consent.statistics,
    marketing: consent.marketing
  };
};

export const init = () => {
  previousConsent = {};

  let consentCookiesWereModified = false;

  // User clicks "Withdraw" on the /cookie-consent page
  document.addEventListener("click", e => {
    if (e.target.matches("#CookieDeclarationChangeConsentWithdraw")) {
      events.emit("cookies:modified");
    }
  });

  events.on("cookies:modified", () => {
    consentCookiesWereModified = true;

    trackConsent();
  });

  events.on("setup:ready", () => {
    if (consentCookiesWereModified) {
      trackConsent();
    }
  });
};
